import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import trCommon from "./locales/tr/common.json";
import trNavigation from "./locales/tr/navigation.json";
import trAuth from "./locales/tr/auth.json";
import trDashboard from "./locales/tr/dashboard.json";
import trProjects from "./locales/tr/projects.json";
import trWorkflows from "./locales/tr/workflows.json";
import trActivities from "./locales/tr/activities.json";
import trForms from "./locales/tr/forms.json";
import trTasks from "./locales/tr/tasks.json";
import trUsers from "./locales/tr/users.json";
import trErrors from "./locales/tr/errors.json";
import trReports from "./locales/tr/reports.json";
import trSettings from "./locales/tr/settings.json";

import enCommon from "./locales/en/common.json";
import enNavigation from "./locales/en/navigation.json";
import enAuth from "./locales/en/auth.json";
import enDashboard from "./locales/en/dashboard.json";
import enProjects from "./locales/en/projects.json";
import enWorkflows from "./locales/en/workflows.json";
import enActivities from "./locales/en/activities.json";
import enForms from "./locales/en/forms.json";
import enTasks from "./locales/en/tasks.json";
import enUsers from "./locales/en/users.json";
import enErrors from "./locales/en/errors.json";
import enReports from "./locales/en/reports.json";
import enSettings from "./locales/en/settings.json";

import deCommon from "./locales/de/common.json";
import deNavigation from "./locales/de/navigation.json";
import deAuth from "./locales/de/auth.json";
import deDashboard from "./locales/de/dashboard.json";
import deProjects from "./locales/de/projects.json";
import deWorkflows from "./locales/de/workflows.json";
import deActivities from "./locales/de/activities.json";
import deForms from "./locales/de/forms.json";
import deTasks from "./locales/de/tasks.json";
import deUsers from "./locales/de/users.json";
import deErrors from "./locales/de/errors.json";
import deReports from "./locales/de/reports.json";
import deSettings from "./locales/de/settings.json";

const resources = {
  tr: {
    common: trCommon,
    navigation: trNavigation,
    auth: trAuth,
    dashboard: trDashboard,
    projects: trProjects,
    workflows: trWorkflows,
    activities: trActivities,
    forms: trForms,
    tasks: trTasks,
    users: trUsers,
    errors: trErrors,
    reports: trReports,
    settings: trSettings,
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    dashboard: enDashboard,
    projects: enProjects,
    workflows: enWorkflows,
    activities: enActivities,
    forms: enForms,
    tasks: enTasks,
    users: enUsers,
    errors: enErrors,
    reports: enReports,
    settings: enSettings,
  },
  de: {
    common: deCommon,
    navigation: deNavigation,
    auth: deAuth,
    dashboard: deDashboard,
    projects: deProjects,
    workflows: deWorkflows,
    activities: deActivities,
    forms: deForms,
    tasks: deTasks,
    users: deUsers,
    errors: deErrors,
    reports: deReports,
    settings: deSettings,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "tr", // Varsayılan dil Türkçe
    defaultNS: "common",
    interpolation: {
      escapeValue: false, // React zaten XSS koruması sağlıyor
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    supportedLngs: ["tr", "en", "de"],
  });

export default i18n;
